<div class="manage-scada-codes-shell">
  @if (mobileSidebarOpen) {
    <button
      type="button"
      class="manage-scada-codes-shell__backdrop"
      aria-label="Close sidebar"
      (click)="closeMobileSidebar()"
    ></button>
  }

  <aside
    class="manage-scada-codes-shell__sidebar"
    [class.manage-scada-codes-shell__sidebar--collapsed]="sidebarCollapsed"
    [class.manage-scada-codes-shell__sidebar--mobile-open]="mobileSidebarOpen"
  >
    <app-dashboard-sidebar [collapsed]="sidebarCollapsed" />
  </aside>

  <div class="manage-scada-codes-shell__content">
    <app-dashboard-header
      [title]="''"
      [subtitle]="''"
      [user]="user"
      [currentTime]="''"
      (menuToggle)="handleMenuToggle()"
    />

    <main class="manage-scada-codes-page">
      <section class="manage-scada-codes-page__panel app-card">
        <div class="manage-scada-codes-page__panel-header">
          <div class="manage-scada-codes-page__heading-copy">
            <h2 class="app-title-serif">Manage SCADA Codes</h2>
          </div>
        </div>

        <div class="manage-scada-codes-page__panel-body">
          <form class="manage-scada-codes-filters" [formGroup]="filterForm">
            <label class="app-form-field manage-scada-codes-filters__field manage-scada-codes-filters__field--search">
              <span class="app-form-label">Search</span>
              <div class="manage-scada-codes-filters__search">
                <span class="manage-scada-codes-filters__search-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="11" cy="11" r="7"></circle>
                    <path d="m20 20-3.5-3.5"></path>
                  </svg>
                </span>
                <input class="app-form-input manage-scada-codes-filters__search-input" type="text" placeholder="Search scada code, ele id..." formControlName="search" />
              </div>
            </label>

            <label class="app-form-field manage-scada-codes-filters__field">
              <span class="app-form-label">Code Type</span>
              <select class="app-form-select" formControlName="code_type">
                @for (option of codeTypeOptions; track option.value) {
                  <option [value]="option.value">{{ option.label }}</option>
                }
              </select>
            </label>

            <button
              type="button"
              class="app-button app-button--secondary equal app-filter-actions__button manage-scada-codes-filters__clear-button"
              [disabled]="isLoading || isSaving || isDeleting || isExporting"
              (click)="clearFilters()"
            >
              Clear
            </button>

            <div class="app-filter-actions manage-scada-codes-filters__actions">
              <button
                type="button"
                class="app-button app-button--primary app-filter-actions__button manage-scada-codes-filters__export-button"
                [disabled]="isLoading || isSaving || isDeleting || isExporting"
                (click)="exportScadaCodes()"
              >
                {{ isExporting ? 'Exporting...' : 'Export Excel' }}
              </button>
            </div>
          </form>

          <div class="manage-scada-codes-page__table-wrap app-table-scroll">
            <table class="manage-scada-codes-table">
              <thead>
                <tr>
                  <th>S. No.</th>
                  <th>Ele ID</th>
<th><button type="button" class="manage-sort-button" (click)="toggleSort('name')" [attr.aria-label]="'Sort by Name'"><span>Name</span><svg class="manage-sort-icon" [class.manage-sort-icon--ascending]="isSortAscending('name')" [class.manage-sort-icon--descending]="isSortDescending('name')" viewBox="0 0 12 16" aria-hidden="true"><path class="manage-sort-icon-up" d="M6 1 2 5h8L6 1Z"></path><path class="manage-sort-icon-down" d="m2 11 4 4 4-4H2Z"></path></svg></button></th>
                  <th>Code Type</th>
<th><button type="button" class="manage-sort-button" (click)="toggleSort('code')" [attr.aria-label]="'Sort by Code'"><span>Code</span><svg class="manage-sort-icon" [class.manage-sort-icon--ascending]="isSortAscending('code')" [class.manage-sort-icon--descending]="isSortDescending('code')" viewBox="0 0 12 16" aria-hidden="true"><path class="manage-sort-icon-up" d="M6 1 2 5h8L6 1Z"></path><path class="manage-sort-icon-down" d="m2 11 4 4 4-4H2Z"></path></svg></button></th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                @if (isLoading) {
                  <tr>
                    <td colspan="6" class="manage-scada-codes-page__empty-state">Loading scada codes...</td>
                  </tr>
                } @else if (filteredScadaCodes.length) {
                  @for (item of filteredScadaCodes; track trackByScadaCodeId($index, item)) {
                    <tr>
                      <td>{{ item.serial_no }}</td>
                      <td>{{ item.ele_id }}</td>
                      <td>{{ item.name }}</td>
                      <td>{{ formatCodeType(item.code_type) }}</td>
                      <td>{{ item.code }}</td>
                      <td>
                        <div class="manage-scada-codes-page__actions">
                          <div class="app-row-action-menu">
                            <details class="app-row-action-menu__details">
                              <summary class="app-row-action-menu__toggle" aria-label="Open scada code actions">
                                <span class="app-row-action-menu__dots" aria-hidden="true">
                                  <span></span>
                                  <span></span>
                                  <span></span>
                                </span>
                              </summary>
                              <div class="app-row-action-menu__dropdown">
                                <button
                                  type="button"
                                  class="app-row-action-menu__item app-row-action-menu__item--view"
                                  (click)="openViewModal(item)"
                                >
                                  <span class="app-row-action-menu__icon app-row-action-menu__icon--view" aria-hidden="true">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                                      <path d="M2.5 12s3.5-6.5 9.5-6.5S21.5 12 21.5 12s-3.5 6.5-9.5 6.5S2.5 12 2.5 12Z"></path>
                                      <circle cx="12" cy="12" r="2.8"></circle>
                                    </svg>
                                  </span>
                                  <span>View</span>
                                </button>
                                <button
                                  type="button"
                                  class="app-row-action-menu__item app-row-action-menu__item--edit"
                                  (click)="openEditModal(item)"
                                >
                                  <span class="app-row-action-menu__icon app-row-action-menu__icon--edit" aria-hidden="true">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                                      <path d="m4 20 4.5-1 11-11a2.1 2.1 0 0 0-3-3l-11 11L4 20Z"></path>
                                      <path d="m13.5 6.5 4 4"></path>
                                    </svg>
                                  </span>
                                  <span>Edit</span>
                                </button>
                                <button
                                  type="button"
                                  class="app-row-action-menu__item app-row-action-menu__item--danger app-row-action-menu__item--delete"
                                  (click)="openDeleteModal(item)"
                                >
                                  <span class="app-row-action-menu__icon app-row-action-menu__icon--delete" aria-hidden="true">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                                      <path d="M3 6h18"></path>
                                      <path d="M8 6V4.5A1.5 1.5 0 0 1 9.5 3h5A1.5 1.5 0 0 1 16 4.5V6"></path>
                                      <path d="M6 6l1 14a1.5 1.5 0 0 0 1.5 1.5h8A1.5 1.5 0 0 0 18 20L19 6"></path>
                                      <path d="M10 10v6"></path>
                                      <path d="M14 10v6"></path>
                                    </svg>
                                  </span>
                                  <span>Delete</span>
                                </button>
                              </div>
                            </details>
                          </div>
                        </div>
                      </td>
                    </tr>
                  }
                } @else {
                  <tr>
                    <td colspan="6" class="manage-scada-codes-page__empty-state">No scada codes found</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>

          @if (canShowPagination()) {
            <div class="manage-scada-codes-page__pagination">
              <div class="manage-scada-codes-page__pagination-summary">
                <span>{{ getPaginationLabel() }}</span>
              </div>

              <div class="manage-scada-codes-page__pagination-actions">
                <button type="button" class="app-button app-button--secondary manage-scada-codes-page__pagination-button" [disabled]="pagination.page_no <= 1 || isLoading" (click)="goToPreviousPage()">
                  Previous
                </button>
                <div class="manage-scada-codes-page__pagination-pages" aria-label="Pagination pages">
                  @for (page of getPaginationItems(); track $index) {
                    @if (page === -1) {
                      <span class="manage-scada-codes-page__pagination-ellipsis" aria-hidden="true">...</span>
                    } @else {
                      <button type="button" class="manage-scada-codes-page__pagination-page" [class.manage-scada-codes-page__pagination-page--active]="pagination.page_no === page" [disabled]="isLoading" (click)="goToPage(page)">{{ page }}</button>
                    }
                  }
                </div>
                <button type="button" class="app-button app-button--secondary manage-scada-codes-page__pagination-button" [disabled]="pagination.page_no >= pagination.total_pages || isLoading || pagination.total_pages === 0" (click)="goToNextPage()">
                  Next
                </button>
              </div>

              <label class="manage-scada-codes-page__pagination-size">
                <span class="manage-scada-codes-page__pagination-size-label">Rows per page</span>
                <select class="app-form-select manage-scada-codes-page__pagination-select" [formControl]="pageSizeControl">
                  @for (size of pageSizeOptions; track size) {
                    <option [ngValue]="size">{{ size }}/Page</option>
                  }
                </select>
              </label>
            </div>
          }
        </div>
      </section>
    </main>
  </div>
</div>

@if (editModalOpen && selectedScadaCode) {
  <div class="app-modal-backdrop">
    <dialog class="app-modal manage-scada-codes-modal" open>
      <div class="manage-scada-codes-modal__header">
        <div class="manage-scada-codes-modal__header-copy">
          <h3>{{ modalMode === 'view' ? 'View SCADA Code' : 'Edit SCADA Code' }}</h3>
          <p>Update the SCADA code values below.</p>
        </div>

        <button type="button" class="app-button app-button--icon manage-scada-codes-modal__close" aria-label="Close modal" (click)="closeEditModal()">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
            <path d="M18 6 6 18"></path>
            <path d="M6 6l12 12"></path>
          </svg>
        </button>
      </div>

      <form class="manage-scada-codes-modal__body" [formGroup]="scadaCodeForm" (ngSubmit)="saveScadaCode()">
        <div class="manage-scada-codes-modal__grid">
          <label class="app-form-field">
            <span class="app-form-label">Ele ID *</span>
            <input class="app-form-input" type="number" placeholder="Enter ele id" formControlName="ele_id" />
            @if (isRequiredFieldInvalid('ele_id')) {
              <section class="app-form-error">Ele ID is required</section>
            }
          </label>

          <label class="app-form-field">
            <span class="app-form-label">Code Type *</span>
            <input class="app-form-input" type="text" placeholder="generator / substation" formControlName="code_type" />
            @if (isRequiredFieldInvalid('code_type')) {
              <section class="app-form-error">Code type is required</section>
            }
          </label>

          <label class="app-form-field manage-scada-codes-modal__full-width">
            <span class="app-form-label">Code *</span>
            <input class="app-form-input" type="text" placeholder="Enter scada code" formControlName="code" />
            @if (isRequiredFieldInvalid('code')) {
              <section class="app-form-error">Code is required</section>
            }
          </label>
        </div>

        <div class="manage-scada-codes-modal__footer">
          <button type="button" class="app-button app-button--secondary" (click)="closeEditModal()">Cancel</button>
          @if (modalMode !== 'view') {
            <button type="submit" class="app-button app-button--primary" [disabled]="isSaving">{{ isSaving ? 'Saving...' : 'Save' }}</button>
          }
        </div>
      </form>
    </dialog>
  </div>
}

@if (deleteModalOpen && selectedScadaCode) {
  <div class="app-modal-backdrop">
    <dialog class="app-modal manage-scada-codes-delete" open>
      <div class="manage-scada-codes-delete__header">
        <div class="manage-scada-codes-delete__icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
            <path d="M12 9v5"></path>
            <path d="M12 17h.01"></path>
            <path d="M10.3 4.5h3.4L21 17.5a1.7 1.7 0 0 1-1.5 2.5H4.5A1.7 1.7 0 0 1 3 17.5L10.3 4.5Z"></path>
          </svg>
        </div>

        <div class="manage-scada-codes-delete__header-copy">
          <h3>Delete SCADA Code</h3>
          <p>This action will move the code to trash.</p>
        </div>

        <button type="button" class="app-button app-button--icon manage-scada-codes-delete__close" aria-label="Close modal" (click)="closeDeleteModal()">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
            <path d="M18 6 6 18"></path>
            <path d="M6 6l12 12"></path>
          </svg>
        </button>
      </div>

      <div class="manage-scada-codes-delete__body">
        Are you sure you want to delete <strong>{{ formatCodeType(selectedScadaCode.code_type) }}</strong> with code <strong>{{ selectedScadaCode.code }}</strong>?
      </div>

      <div class="manage-scada-codes-delete__footer">
        <button type="button" class="app-button app-button--secondary" (click)="closeDeleteModal()">Cancel</button>
        <button type="button" class="app-button app-button--danger" [disabled]="isDeleting" (click)="confirmDelete()">{{ isDeleting ? 'Deleting...' : 'Delete' }}</button>
      </div>
    </dialog>
  </div>
}
